<template>
  <div class="w-100 pt-4">
    <v-client-table
      class="v-table row-pointer"
      :data="logdata"
      :columns="columns"
      :options="options"
    >
      <template slot="status" slot-scope="{ row }">
        <span :class="statusColor(row.status)">
          {{ titleCase(row.status) }}
        </span>
      </template>
      <template slot="createdAt" slot-scope="{ row }">
        {{ timeDateFormat(row.createdAt).date }}
        {{ timeDateFormat(row.createdAt).time }}
      </template>
    </v-client-table>
  </div>
</template>

<script>
import { componentData } from "../../../../../public/assets/mixins";
import {
  tableOptions,
  timeDateFormat,
  statusColor,
  titleCase,
} from "../../../../components/utils/helpers";

const tableHeadings = {
  serial_no: "S/N",
  reference: "Reference",
  amount: "Amount",
  currency: "Currency",
  status: "Status",
  createdAt: "Date Created",
};

export default {
  name: "AccountCreditLog",
  data() {
    return { ...tableOptions(tableHeadings, 25) };
  },
  props: ["logs"],
  mixins: [componentData],

  computed: {
    logdata() {
      return this.logs.data.map((obj, i) => ({
        serial_no: i + 1,
        ...obj,
      }));
    },
  },
  methods: {
    timeDateFormat,
    titleCase,
    statusColor,
    async fetchCustomersDetails() {
      this.options.requestFunction = async (data) => {
        const params = { ...data, ...this.filters };
        const response = await tthis.$store.dispatch(
          "customer/getSingleCustomerAdditionalDetails",
          { clientid: this.clientid, ...params }
        );

        const newData = response.data.data.credit_history;
        const count = response.data.count;
        return { ...response, count, total: count, data: newData };
      };
    },
    async fetchCustomerAdditionalDetails() {
      try {
        this.isOthersLoading = true;
        let apiResponseAdditionalDetails = await this.$store.dispatch(
          "customer/getSingleCustomerAdditionalDetails",
          { clientid: this.clientid }
        );
        const customer = {
          ...this.customer,
          ...apiResponseAdditionalDetails,
        };
        this.customer = customer;
        this.apiUser = customer;
        this.isOthersLoading = false;
      } catch (error) {
        this.isOthersLoading = false;
        this.showErrorLoginNotification(error.message);
      }
    },
  },
  mounted() {
    this.fetchCustomersDetails();
    this.columns = Object.keys(tableHeadings).map((keyVal) => keyVal);
  },
};
</script>
